import {
  MockMap,
} from '@ama-sdk/core';
import {
  Journey,
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneys,
  combineJourneyTravelers,
  ContextualSeatmapDataRepository,
  createJourney,
  createMockData,
  createMockDataWithResponse,
  JourneyTravelerRepository,
  RecursivePartial,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  contactEmail,
  contactPhone,
} from '../../mock/dictionaries';

const journeyTemplate: RecursivePartial<Journey> = {
  travelers: combineJourneyTravelers([JourneyTravelerRepository.MAN, JourneyTravelerRepository.WOMAN, JourneyTravelerRepository.CHD, JourneyTravelerRepository.INF], {}).items,
  contacts: [contactEmail, contactPhone]
};

const notificationContact = [{
  ...contactEmail,
  purpose: 'notification',
  travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
}, {
  ...contactPhone,
  purpose: 'notification'
},
{
  ...contactEmail,
  purpose: 'notification',
  travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
}, {
  ...contactPhone,
  purpose: 'notification'
},
{
  ...contactEmail,
  purpose: 'notification',
  travelerIds: ['JOURNEY-TRAVELER-2-MOCK']
}, {
  ...contactPhone,
  purpose: 'notification'
}];

const journeys = combineJourneys([{
  ...journeyTemplate,
  contacts: notificationContact
}]).items;

const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);

export const ow1journey2Adt1Chd1InfRetrive: MockMap = {
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(undefined, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([
      createJourney({
        template: {
          ...journeys[0],
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    ], 201)
  ],
  retrieveJourney: [
    createMockData(
      createJourney({
        template: {
          ...journeys[0],
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    )
  ],
  addContactsToJourney: [
    createMockData([{
      ...contactEmail,
      address: 'toto@free.fr',
      purpose: 'notification',
      travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
    },
    {
      ...contactPhone,
      purpose: 'notification',
      countryPhoneExtension: '33',
      number: '0623456789',
      travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
    },
    {
      ...contactEmail,
      address: 'tata@free.fr',
      purpose: 'notification',
      travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
    },
    {
      ...contactPhone,
      purpose: 'notification',
      countryPhoneExtension: '33',
      number: '0623456781',
      travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
    },
    {
      ...contactEmail,
      address: 'tata@free.com',
      purpose: 'notification',
      travelerIds: ['JOURNEY-TRAVELER-2-MOCK']
    },
    {
      ...contactPhone,
      purpose: 'notification',
      countryPhoneExtension: '33',
      number: '0623456781',
      travelerIds: ['JOURNEY-TRAVELER-2-MOCK']
    }
    ])
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(ContextualSeatmapDataRepository.DEFAULT)]
};
